import { useMutation } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';

type RemoteSpeakerLaunchRequest = {
  contributorId: string;
  /** Contributor role slot (`roles[].slots[].id`) the speaker joins from. */
  roleSlotId: string;
};

/**
 * Single-use code for the remote speaker console. The code goes in the URL fragment, so it never reaches
 * a server log or a Referer header; the player removes it from the address bar on load.
 */
export function buildRemoteSpeakerConsoleUrl(code: string): string {
  const base = import.meta.env.VITE_PLAYER_APP_URL ?? 'https://player.britestage.com';
  return `${base.replace(/\/$/, '')}/#rs=${encodeURIComponent(code)}`;
}

export const useRemoteSpeakerLaunchMutation = () => {
  const { getToken } = useAuth();
  return useMutation({
    mutationFn: async (body: RemoteSpeakerLaunchRequest): Promise<{ code: string }> => {
      const token = await getToken();
      return sendJSONRequest({
        url: `${import.meta.env.VITE_API_URL}/player/remote-speaker/launch`,
        method: METHOD.POST,
        body,
        token: token ?? '',
      }) as Promise<{ code: string }>;
    },
  });
};
